var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2755 14.9822L2.33754 15.1152C1.91457 15.1187 1.57129 14.7721 1.57129 14.3489V11.7628C1.57129 11.3399 1.91438 10.9966 2.33754 10.9966L18.3866 11.2292L18.2755 14.9822Z",
    fill: "#A57939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80452 15.1815H1.95424C1.53127 15.1815 1.18799 15.4502 1.18799 15.7815V17.5818C1.18799 17.9132 1.53108 18.1818 1.95424 18.1818H18.0455C18.4685 18.1818 18.8117 17.9131 18.8117 17.5818V15.7815C18.8117 15.4501 18.4687 15.1815 18.0455 15.1815H11.2297",
    fill: "#F4AA41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5972 15.1164H18.0453C18.4683 15.1164 18.8115 15.391 18.8115 15.7298V17.5699C18.8115 17.9086 18.4685 18.1833 18.0453 18.1833H14.5972V15.1164Z",
    fill: "#E27022"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8117 6.77578C18.8117 7.05327 18.4687 7.27844 18.0455 7.27844H1.95424C1.53127 7.27844 1.18799 7.05346 1.18799 6.77578C1.75655 3.91575 5.48282 1.70703 9.99987 1.70703C14.5169 1.70703 18.2447 3.91575 18.8117 6.77578Z",
    fill: "#F4AA41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2988 2.02876C13.4766 3.29269 14.2742 5.02595 14.5976 7.26608H18.0457C18.4687 7.26608 18.812 7.04625 18.812 6.7753C18.2373 4.01642 14.7278 2.35787 12.2988 2.02838V2.02876Z",
    fill: "#E27022"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.946 10.7307H6.65137L9.79868 13.878L12.946 10.7307Z",
    fill: "#FCEA2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5972 10.9709V15.1164H17.6622C18.0851 15.1164 18.4284 14.7733 18.4284 14.3501V11.764C18.4284 11.341 18.0853 10.9978 17.6622 10.9978H15.1083",
    fill: "#6A462F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5398 8.18182H2.46387V8.9837H17.5398V8.18182Z",
    fill: "#EA5A47",
    stroke: "#EA5A47",
    strokeWidth: 0.689625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9956 8.18182H17.5476V8.99635H14.9956V8.18182Z",
    fill: "#D22F27",
    stroke: "#D22F27",
    strokeWidth: 0.689625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29519 10.4384L17.8424 10.2917C18.6899 10.1058 18.8075 9.90055 18.8891 9.42317C18.1761 9.90821 17.6244 9.91281 17.1336 9.97411C16.2452 9.96971 15.4241 9.98346 14.8605 9.26532L12.5629 9.09422L10.9009 9.82752L9.23895 9.80308L7.4057 9.16748L5.45023 9.0697C4.98205 9.63481 4.10086 9.79841 3.56793 9.97426C2.75034 9.82373 1.87529 10.284 1.1167 9.42333C1.30424 10.0126 1.30773 10.1792 2.29672 10.4386L2.29519 10.4384Z",
    fill: "#B1CC33",
    stroke: "#B1CC33",
    strokeWidth: 0.689625,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9883 10.7258L17.838 10.2913C18.6854 10.1054 18.8031 9.90016 18.8847 9.42278C18.1717 9.90782 17.62 9.91242 17.1292 9.97372C16.2407 9.96932 16.3292 9.96638 15.5664 9.5837L14.9883 9.24927V10.7258Z",
    fill: "#5C9E31",
    stroke: "#5C9E31",
    strokeWidth: 0.689625,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9956 8.18182H16.599V8.99635H14.9956V8.18182Z",
    fill: "#D22F27",
    stroke: "#D22F27",
    strokeWidth: 0.689625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakLogo);
export default __webpack_public_path__ + "static/media/break-logo.e9345562cc0bbb2806f8430f18c26225.svg";
export { ForwardRef as ReactComponent };